import Vue from 'vue'
import Vuex from 'vuex'
import CstSurvey from '@/components/CstSurvey'
import axios from 'axios'
import router from './../router'
import { i18n } from '@/components/i18n.js'
import { Validator } from 'vee-validate/dist/vee-validate.minimal.esm.js'
Vue.use(Vuex)

var cst_survey_obj = new CstSurvey()

const store = new Vuex.Store({
  state: cst_survey_obj,
  getters: {
    getCardById: (state) => (card_id) => {
      return store.state.decks[0].cards[card_id - 1]
    },
    getNextCard: function () {
      var card = store.state.getNextCard()
      // var card = store.state.decks[store.state.current_deck_index].getNextCard();
      if (!card) {
        this.current_deck_index++
        return this.getNextCard()
      }
      return card
    }
  //    getAnswerByQuestion: (state) => (questionId) => {
  //      return store.state.answers[questionId]
  //    }
  },
  computed: {
    count () {
      return store.state.current_card_index
    }
  },
  mutations: {
    startLoading: function (state, overlayData) {
      state.loadingOverlay = overlayData
    },
    endLoading: function (state) {
      state.loadingOverlay = false
    },
    setCustomer: function (state) {

    },
    addCard: function (state, card) {
      state.cards.push(card)
      if (card.needsOverflow) {
        state.needsOverflow = true
      } else {
        state.needsOverflow = false
      }
    },
    removeCard: function (state) {
      state.cards.splice(-1, 1)
    },
    setHotelData: function (state, hotelData) {
      state.hotelData = hotelData
    },
    setSelectedModules: function (state, selectedModules) {
      state.selectedModules = selectedModules
    },
    setLocale: function (state, locale) {
      state.locale = locale
      i18n.locale = locale
      Validator.localize(locale)
    },
    setTransition: function (state, transitionName) {
      state.transition = transitionName
    },
    setCardIndex: function (state, newIndex) {
      state.current_card_position = newIndex * 1
    },
    setOverflow: function (state, overFlow) {
      state.needsOverflow = overFlow
    }
  },
  actions: {
    postData: function (context, url, postData) {
      context.commit('startLoading', { text: 'Loading...' })
      return new Promise((resolve, reject) => {
        axios.post(url, postData)
          .then(function (response) {
            context.commit('endLoading')
            resolve(response.data)
          })
          .catch(function (error) {
            context.commit('endLoading')
            reject(error)
          })
      })
    },
    getData: function (context, url, overlayData) {
      context.commit('startLoading', { text: 'Loading...' })
      return new Promise((resolve, reject) => {
        axios.get(url)
          .then(function (response) {
            context.commit('endLoading')
            resolve(response.data)
          })
          .catch(function (error) {
            context.commit('endLoading')
            reject(error)
          })
      })
    },
    setLocale: function (context, locale) {
      context.commit('startLoading', { text: 'Loading...' })
      context.commit('setLocale', locale)
      // return context.state.changeLocale(locale).then(() => context.state.updateSurveyLanguage(locale)).then(() => context.commit('endLoading'))
      return context.state.changeLocale(locale).then(() => context.commit('endLoading'))
    },
    getSurvey: function (context, surveyData) {
      context.commit('startLoading', { text: 'Loading...' })
      return context.state.loadSurvey(surveyData.surveyId, surveyData.surveyKey, surveyData.language).then(() => context.commit('endLoading'))
    },
    createSurvey: function (context, customerVisitData) {
      customerVisitData.visit.from.value = customerVisitData.visit.from.value.toISOString().split('T')[0]
      customerVisitData.visit.to.value = customerVisitData.visit.to.value.toISOString().split('T')[0]

      context.commit('startLoading', { text: 'Loading...' })
      return context.state.createSurvey(customerVisitData.customer, customerVisitData.visit).then(() => context.commit('endLoading'))
    },
    initSurvey: function (context) {
      context.commit('startLoading', { text: 'Loading...' })
      return context.state.initSurvey().then(() => context.commit('endLoading'))
    },
    getHotelData: function (context) {
      context.commit('startLoading', { text: 'Loading...' })
      return context.state.getHotelData(store.state.hotel_id).then(() => context.commit('endLoading'))
    },
    finishSurvey: function (context) {
      // context.commit('startLoading', { text: 'Loading...' })
      // todo: finish status wechseln, falls spaeter jmd in den cards springt
      return context.state.finishSurvey()
      // .then(() => context.commit('endLoading'))
    },
    loadExtendedSurvey: function (context, selectedFilters) {
      context.commit('startLoading', { text: 'Loading...' })
      return context.state.loadExtendedSurvey(selectedFilters).then(() => context.commit('endLoading'))
    },
    loadExternalSurvey: function (context, surveyType) {
      context.commit('startLoading', { text: 'Loading...' })
      return context.state.loadExternalSurvey(surveyType).then(() => context.commit('endLoading'))
    },
    submitExternalSurvey: function (context, surveyData) {
      context.commit('startLoading', { text: 'Loading...' })
      return context.state.submitExternalSurvey(surveyData).then((data) => { context.commit('endLoading'); return data })
    },
    setReview: function (context, reviewData) {
      return context.state.setReview(reviewData)
    },
    gotoNamedCard: function (context, cardName) {
      context.state.gotoNamedCard(cardName).then((card_index) => {
        router.push({ name: 'card', params: { cardId: card_index } })
      })
    },
    addCard: function (context, card) {
      context.commit('addCard', card)
      return context.state.cards.length - 1
    },
    removeCard: function (context) {
      context.state.removeCard(context.state.cards.slice(-1)[0])
      context.commit('removeCard')
    },
    updateProgress: function (context) {
      if (context.state.surveyId * 1 === 0) {
        return
      }
      // das gehoert eigentlich in survey oder?
      var allCardCount = context.state.cards.length - 1 + context.state.getRemainingCardCount()
      var progressPosition = context.state.current_card_position
      var progressPct = (progressPosition / allCardCount) * 100
      progressPct = Math.round(progressPct * 10) / 10
      if (progressPct > context.state.maxProgressPct) {
        context.state.updateSurveyProgress(progressPct)
      }
      if (progressPct !== context.state.currentProgressPct) {
        context.state.currentProgressPct = progressPct
      }
      context.state.maxProgressPct = Math.max(context.state.maxProgressPct, progressPct)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/components/store.js